export default __webpack_public_path__ + "static/media/dry goods_cat_disabled.cf038e25.png";